import React from 'react';

import PropTypes from 'prop-types';

import { LinkButton } from '@adsk/alloy-react-button';
import EmptyState from '@adsk/alloy-react-empty-state';
import { noop } from '@adsk/alloy-react-helpers';
import { useLocale } from '@adsk/alloy-react-locale';

import { useCollection } from './providers/CollectionProvider';
import { useSearchPanel } from './providers/SearchPanelProvider';
import { pluginShape } from '../../helpers/propTypes';
import EntityPickerModalEmptyState from '../../modal/EntityPickerModalEmptyState';
import EntityPickerModalNoSearchResults from '../../modal/EntityPickerModalNoSearchResults';

const SheetCustomNoData = ({ filters, clearFilters, plugin }) => {
  const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));

  const { isFeatureEnabled: enableCollectionFeature } = useCollection();
  const { resetSearchPanel } = useSearchPanel();

  const clearSearch = () => {
    clearFilters();
    resetSearchPanel();
  };

  if (filters && Object.keys(filters).length > 0) {
    return enableCollectionFeature ? (
      <EmptyState
        illustrationType={EmptyState.ILLUSTRATION_TYPES.FOLDER_PHOTO_GREY}
        title={T.translate('NO_RESULTS_TITLE')}
        description={T.translate('NO_RESULTS_DESCRIPTION')}
      >
        <LinkButton onClick={clearSearch}>
          {T.translate('CLEAR_SEARCH')}
        </LinkButton>
      </EmptyState>
    ) : (
      <EntityPickerModalNoSearchResults
        clearFilters={clearFilters}
        filters={filters}
      />
    );
  }

  return (
    <EntityPickerModalEmptyState
      canCreate={false}
      plugin={plugin}
      onCreateClick={noop}
    />
  );
};

SheetCustomNoData.propTypes = {
  /**
   * The currently applied filters.
   */
  filters: PropTypes.object,
  /**
   * Callback to clear filters.
   */
  clearFilters: PropTypes.func,
  /**
   * The plugin to use to render empty state
   */
  plugin: pluginShape.isRequired,
};

export default SheetCustomNoData;
